import FieldWithError from './FieldWithError';
const FieldSection = ({ section, questionnaireForm, form, t, validateField }) => {
    const rootField = section.fields[0];
    const formFields = rootField.type === 'group' ? section.fields.slice(1) : section.fields;
    const fieldsContent = (<div className="flex flex-col gap-3">
            {rootField.type === 'group' && <label className="label-m">{rootField.label}</label>}
            {formFields.map((field) => {
            var _a;
            return (<FieldWithError key={field.name} field={field} form={form} t={t} parentLabel={field.reqif ? (_a = questionnaireForm[field.reqif.split('=')[0]]) === null || _a === void 0 ? void 0 : _a.label : undefined} validateField={validateField}/>);
        })}
        </div>);
    if (section.description) {
        return (<div className="flex flex-col md:flex-row gap-6">
                <div className="flex-[3] min-w-0">{fieldsContent}</div>
                <p className="flex-[2] min-w-0 body-s text-neutral-secondary-initial">{section.description}</p>
            </div>);
    }
    return <div>{fieldsContent}</div>;
};
export default FieldSection;
